module.exports = __webpack_public_path__ + "img/1f63d.6a68dc8.svg";